module.exports = __webpack_public_path__ + "static/media/tencon.16f0e7f3.png";